import { getDevicePermission } from 'utils/getDevicePermission';

const isTalkingLevel = 0.04;

/**
 * Отслеживание уровня звука из микрофона
 *
 * @returns Promise c функцией от прекращения отслеживания уровня микрофона
 */
export async function manageMicrophoneLevel(getIsTalkingState: (isTalking: boolean) => void) {
    const stream = await getDevicePermission({ audio: true });
    const audioContext = new AudioContext();

    await audioContext.audioWorklet.addModule(new URL('static/js/audioWorklet.js', import.meta.url));
    const audioLevelNode = new AudioWorkletNode(audioContext, 'audio-level-processor');

    function messageHandler(e: { data: { level: number } }) {
        const userIsTalking = e.data.level >= isTalkingLevel;

        getIsTalkingState(userIsTalking);
    }
    audioLevelNode.port.onmessage = messageHandler;
    const micNode = audioContext.createMediaStreamSource(new MediaStream(stream));

    micNode.connect(audioLevelNode);
    audioLevelNode.connect(audioContext.destination);

    return () => {
        audioLevelNode.disconnect();
        audioLevelNode.port.close();

        micNode.mediaStream.getAudioTracks().forEach(track => {
            track.stop();
        });

        micNode.disconnect();

        return Promise.resolve(
            (() => {
                if (audioContext.state !== 'closed') {
                    audioContext.close();
                }
            })(),
        );
    };
}
